/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Street/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Street({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Address/Addresses/Content/Address/Edit/Content/Fields/Street",
  isInvalid,
  onChange
  
}) {
let editAddressAddressLine1ValueData = fromData.useDataValue({ viewPath,
context: 'edit_address',
path: 'address_line1',
})
let editAddressAddressLine1IsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_address',
path: 'address_line1',
validate: fromValidate.street,
})
let editAddressAddressLine1ChangeData = fromData.useDataChange({ viewPath,
context: 'edit_address',
path: 'address_line1',
})
let onChooseAddress = fromHelpers.useOnClick({
  children,
  viewPath,
  isInvalid,
  onChange
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_address.address_line1"
 validate="/Data/validate.js street"
 invalid={!editAddressAddressLine1IsValidData}
 value={editAddressAddressLine1ValueData}
 onChange={editAddressAddressLine1ChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Street"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 focusOnDownArrowKey={true}
 onChooseAddress={onChooseAddress}
 type="address"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}